"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Switch;

var _react = _interopRequireDefault(require("react"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Field = _interopRequireDefault(require("../Field"));

require("bulma-switch");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Switch(props) {
  var _classnames;

  var className = props.className,
      disabled = props.disabled,
      size = props.size,
      labelSide = props.labelSide,
      label = props.label,
      checked = props.checked,
      onChange = props.onChange,
      thin = props.thin,
      info = props.info,
      success = props.success,
      danger = props.danger,
      outlined = props.outlined,
      rounded = props.rounded;
  return /*#__PURE__*/_react.default.createElement(_Field.default, _extends({}, props, {
    label: null,
    className: (0, _classnames2.default)('frikin-switch-field', className)
  }), /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    checked: checked,
    onChange: function onChange() {},
    className: (0, _classnames2.default)('switch', (_classnames = {}, _defineProperty(_classnames, "is-".concat(size), size), _defineProperty(_classnames, 'is-info', info), _defineProperty(_classnames, 'is-success', success), _defineProperty(_classnames, 'is-danger', danger), _defineProperty(_classnames, 'is-outlined', outlined), _defineProperty(_classnames, 'is-rounded', rounded), _defineProperty(_classnames, 'is-thin', thin), _defineProperty(_classnames, 'is-disabled', disabled), _defineProperty(_classnames, 'is-rtl', labelSide === 'right'), _classnames))
  }), /*#__PURE__*/_react.default.createElement("label", {
    onClick: !disabled ? onChange : undefined
  }, label));
}

Switch.propTypes = {
  label: _propTypes.default.any,
  checked: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  className: _propTypes.default.string,
  onChange: _propTypes.default.func,
  size: _propTypes.default.string,
  labelSide: _propTypes.default.string,
  success: _propTypes.default.bool,
  danger: _propTypes.default.bool,
  outlined: _propTypes.default.bool,
  rounded: _propTypes.default.bool,
  thing: _propTypes.default.bool
};
Switch.defaultProps = {
  onChange: function onChange() {}
};